import React from 'react';
import { Tag } from 'react-tag-autocomplete';
import { getTagsForDisplay, TAG_DISPLAY_LIMIT } from '@/utils/recipientParser';

interface RecipientTagListProps {
  tags: Tag[];
  expanded: boolean;
  onToggleExpand: () => void;
  onRemove: (index: number) => void;
  onClearAll: () => void;
}

const RecipientTagList: React.FC<RecipientTagListProps> = ({
  tags,
  expanded,
  onToggleExpand,
  onRemove,
  onClearAll,
}) => {
  const { visible } = getTagsForDisplay(tags, expanded);
  const hasMoreThanLimit = tags.length > TAG_DISPLAY_LIMIT;
  const collapsedHiddenCount = tags.length - TAG_DISPLAY_LIMIT;

  return (
    <>
      {visible.map((tag, index) => (
        <div
          key={`${String(tag.value)}-${index}`}
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#dbeafe',
            color: '#1e40af',
            borderRadius: '20px',
            padding: '4px 12px',
            fontSize: '14px',
            fontWeight: '500',
            gap: '8px',
            flexShrink: 0,
          }}
        >
          <span>{tag.label}</span>
          <button
            type="button"
            style={{
              background: 'none',
              border: 'none',
              color: '#6b7280',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '16px',
              height: '16px',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.color = '#dc2626'; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = '#6b7280'; }}
            onClick={() => onRemove(index)}
          >
            ×
          </button>
        </div>
      ))}

      {hasMoreThanLimit && (
        <button
          type="button"
          onClick={onToggleExpand}
          aria-expanded={expanded}
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#eff6ff',
            color: '#1d4ed8',
            border: '1px solid #bfdbfe',
            borderRadius: '20px',
            padding: '4px 12px',
            fontSize: '13px',
            fontWeight: '600',
            cursor: 'pointer',
            flexShrink: 0,
          }}
        >
          {expanded ? `Show top ${TAG_DISPLAY_LIMIT}` : `+${collapsedHiddenCount} more`}
        </button>
      )}

      {tags.length > 1 && (
        <button
          type="button"
          onClick={onClearAll}
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#fef2f2',
            color: '#b91c1c',
            border: '1px solid #fecaca',
            borderRadius: '20px',
            padding: '4px 12px',
            fontSize: '12px',
            fontWeight: '600',
            cursor: 'pointer',
            flexShrink: 0,
          }}
        >
          Clear all ({tags.length})
        </button>
      )}
    </>
  );
};

export default RecipientTagList;
